import React, { useState } from 'react';
import Button from './Button';
import Input from './Input';
import Card from './Card';


const ContactPage = ({ navigate }) => {
  const [formName, setFormName] = useState('');
  const [formPhone, setFormPhone] = useState('');
  const [formEmail, setFormEmail] = useState('');
  const [formMessage, setFormMessage] = useState('');
  const [formStatus, setFormStatus] = useState('idle');
  const [formError, setFormError] = useState('');

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('sending');
    setFormError('');
    try {
      const serviceInterest = window.history.state?.serviceInterest || '';
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: formName, phone: formPhone, email: formEmail, message: formMessage, service: serviceInterest }),
      });
      const data = await res.json();
      if (!res.ok) {
        setFormError(data.error || 'Something went wrong.');
        setFormStatus('error');
      } else {
        setFormStatus('success');
        setFormName('');
        setFormPhone('');
        setFormEmail('');
        setFormMessage('');
      }
    } catch (err) {
      setFormError('Could not reach the server. Make sure it is running.');
      setFormStatus('error');
    }
  };

  return (
    <div className="py-32 max-w-[95vw] mx-auto px-4 md:px-8 bg-background min-h-screen flex flex-col justify-center">
      <div className="max-w-6xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
        
        {/* Left Column: Form */}
        <div>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold uppercase tracking-tighter mb-12 leading-none">
            CONTACT US
          </h1>
          
          {formStatus === 'success' ? (
            <div className="border-2 border-accent bg-background p-10 text-center space-y-4">
              <div className="text-5xl">✓</div>
              <h3 className="text-3xl font-black uppercase tracking-tighter text-foreground" style={{ fontFamily: "'Poppins Black', sans-serif" }}>
                Message Sent
              </h3>
              <p className="text-muted-foreground text-lg">We'll be in touch soon.</p>
              <button
                onClick={() => setFormStatus('idle')}
                className="mt-4 text-xs uppercase tracking-widest font-black text-accent hover:text-foreground transition-colors focus:outline-none"
              >
                Send another message
              </button>
            </div>
          ) : (
            <form className="space-y-8" onSubmit={handleContactSubmit}>
              <div>
                <Input
                  placeholder="NAME"
                  value={formName}
                  onChange={(e) => setFormName(e.target.value)}
                  required
                />
              </div>
              {/* <div>
                <Input
                  type="tel"
                  placeholder="PHONE"
                  value={formPhone}
                  onChange={(e) => setFormPhone(e.target.value)}
                />
              </div> */}
              <div>
                <Input
                  type="email"
                  placeholder="EMAIL"
                  value={formEmail}
                  onChange={(e) => setFormEmail(e.target.value)}
                  required
                />
              </div>
              <div>
                <Input
                  as="textarea"
                  placeholder="MESSAGE"
                  value={formMessage}
                  onChange={(e) => setFormMessage(e.target.value)}
                  required
                />
              </div>
              {formStatus === 'error' && (
                <p className="text-sm uppercase tracking-widest font-bold text-red-400">{formError}</p>
              )}
              <Button
                size="large"
                type="submit"
                className="w-full"
                disabled={formStatus === 'sending'}
              >
                {formStatus === 'sending' ? 'Sending...' : 'Send Message'}
              </Button>
            </form>
          )}
        </div>

        {/* Right Column: Contact Info */}
        <div className="flex flex-col justify-center space-y-12">
          <Card className="hoverable-false cursor-default">
            <h3 className="text-2xl md:text-3xl font-bold uppercase tracking-tighter mb-2" style={{ fontFamily: "'Poppins Black', sans-serif" }}>
              Call Us
            </h3>
            <p className="text-xl md:text-2xl text-muted-foreground font-medium">
              (847) 714-4721
            </p>
          </Card>
          <Card className="hoverable-false cursor-default">
            <h3 className="text-2xl md:text-3xl font-bold uppercase tracking-tighter mb-2" style={{ fontFamily: "'Poppins Black', sans-serif" }}>
              Send a Message
            </h3>
            <p className="text-xl md:text-2xl text-muted-foreground font-medium">
              info@wind-marketing.com
            </p>
          </Card>
        </div>

      </div>
    </div>
  );
};

export default ContactPage;
